// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xuDHVLMSGgdGn9 {
  display: flex;
  align-items: center;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-200, 16px);
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-surface-sunken, #f7f8f9);
  text-align: left;
  cursor: pointer;
}
.xuDHVLMSGgdGn9 .VwbrzaKaxQqL1M {
  display: flex;
  flex: 1;
}
.xuDHVLMSGgdGn9:hover {
  background-color: var(--ds-background-neutral-subtle-hovered, #091e420f);
}
.xuDHVLMSGgdGn9.uicOYcNughyFge {
  background-color: var(--ds-background-selected, #e9f2ff);
  box-shadow: inset 0 0 0 2px var(--ds-border-selected, #0c66e4);
}
.xuDHVLMSGgdGn9 .QhJ_vG8GWQs90H {
  padding-right: var(--ds-space-150, 12px);
}
.xuDHVLMSGgdGn9 .xVJjaUfKRvwrZB {
  flex: 1;
}
.xuDHVLMSGgdGn9 .rDjZBZ306XNaNC {
  font-size: 14px;
  font-weight: var(--ds-font-weight-bold, bold);
  line-height: 20px;
  text-overflow: ellipsis;
}
.xuDHVLMSGgdGn9 .MFQMsn4tq1ylQU {
  height: 14px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 11px;
  line-height: 14px;
}
.xuDHVLMSGgdGn9 + .xuDHVLMSGgdGn9 {
  margin-top: var(--ds-space-100, 8px);
}
`, ""]);
// Exports
export var listItemContainer = `xuDHVLMSGgdGn9`;
export var listItem = `VwbrzaKaxQqL1M`;
export var selected = `uicOYcNughyFge`;
export var avatar = `QhJ_vG8GWQs90H`;
export var text = `xVJjaUfKRvwrZB`;
export var name = `rDjZBZ306XNaNC`;
export var info = `MFQMsn4tq1ylQU`;
export default ___CSS_LOADER_EXPORT___;
